/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyBilledCost {
    getFixupPrototypeFunction() { return CostAnomalyBilledCost.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyBilledCost>): CostAnomalyBilledCost {
        let obj = Object.assign(new CostAnomalyBilledCost(), model);
        CostAnomalyBilledCost.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyBilledCost>): CostAnomalyBilledCost {
        if (!model) return null;
        return CostAnomalyBilledCost.newInstance(<CostAnomalyBilledCost> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyBilledCost) {
        if (!obj) return;

        models.CostAnomalyBilledCost.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyBilledCost): boolean {
        Object.setPrototypeOf(obj, CostAnomalyBilledCost.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost === undefined) {
            this.cost = 0;
        }
        if (typeof this.bill_date === "string") {
            this.bill_date = new Date(<string><any>this.bill_date);
        }
    }

    /**
     * Bill date in yyyy-mm-dd format
     */
    bill_date: Date;

    /**
     * Billed cost for the bill date.
     */
    cost: number;

}
